import React, { useEffect, useState } from 'react'
import * as Yup from "yup";
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { Form, FormikProvider, useFormik } from "formik";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import { AUTH_API_URL } from "src/api/axios";
import { useMutation, useQuery } from 'react-query';
import { ROLE_API_URL } from "src/api/axios";
import { useSnackbar } from "notistack";
import FormHelperText from "@mui/material/FormHelperText";
import DefaultImage from "../../assets/images/Default_image.png";
import LoadingScreen from 'src/components/LoadingScreen';
import { Autocomplete, LoadScript } from "@react-google-maps/api";
import InputAdornment from '@mui/material/InputAdornment';
import GoogleIcon from 'src/svgComponents/GoogleIcon';
import AppTooltip from 'src/components/common/AppTooltip';
import { Switch } from '@material-ui/core';

const SubVendorProfile = () => {
   const axiosPrivate = useAxiosPrivate();
   const { enqueueSnackbar } = useSnackbar();
   const [selectRoleData, setRoleData] = useState([]);
   const [profilePic, setProfilePic] = useState("");
   const [kycPic, setKycPic] = useState("");
   const [kycImageName, setKycImageName] = useState();
   const [mainImageName, setMainImageName] = useState();
   const [loding, setLoding] = useState(false);
   const [locationLat, setLocationLat] = useState();
   const [locationLng, setLocationLng] = useState();
   const [address, setAddress] = useState();
   const [location, setlocation] = useState();
   const [colDir, setColDir] = useState("row");
   const [category, setCategory] = useState();
   const [subcategory, setSubCategory] = useState([]);
   const [getSubCategoryData, setSubCategoryData] = useState([])
   const [category_type, setCategoryType] = useState('');
   const [delivery_available, setDeliveryAvailable] = useState(false)

   const { data: userData } = useQuery(
      "locationData",
      async ({ signal }) => {
         return await axiosPrivate
            .get(AUTH_API_URL.getProfile)
            .then((res) =>
               res.data
            ).catch((err) => {
               console.log(err);
            });
      },
      { refetchOnWindowFocus: false }
   );

   async function fetchRole() {
      const response = await axiosPrivate.get(ROLE_API_URL.getRoleList)
      return response.data;
   }

   const { isLoading: isLoadingRole, data: roleList, refetch: refetchRole } = useQuery(['roleList'], () => fetchRole(), { keepPreviousData: true, })
   useEffect(() => {
      if (roleList) {
         setRoleData(roleList.data ? [] : roleList);
      }
      if (userData) {
         setSubCategoryData(userData?.sub_categories ? userData.sub_categories : []);
      }
   }, [roleList, userData])

   useEffect(() => {
      if (userData) {
         setCategoryType(userData?.vendor?.category_type)
         setSubCategory(userData?.vendor?.subCategories)
         setDeliveryAvailable(userData?.vendor?.delivery_available)
         setFieldValue("name", userData?.vendor?.name ? userData?.vendor?.name : "");
         setFieldValue("email", userData?.vendor?.email ? userData?.vendor?.email : "");
         setFieldValue("businessPhone", userData?.vendor?.businessPhone ? userData?.vendor?.businessPhone : "");
      }
   }, [userData])
   const mainCategory = [
      { value: 1, name: "Restaurant" },
      { value: 2, name: "Grocery" },
      { value: 3, name: "Event" },
      { value: 4, name: "Travel" },
      { value: 5, name: "NGO" },
   ]
   const completedSchema = Yup.object().shape({
      name: Yup.string()
         .min(2, "frist name can set of between 2 and 50 characters!")
         .max(50, "first name can set of between 2 and 50 characters!")
         .required("first name is required"),
      email: Yup.string()
         .email("email must be a valid email address")
         .required("email is required"),
      businessPhone: Yup.string()
         .min(8, "Business Phone must be 8-15 digit!")
         .max(15, "Business Phone must be 8-15 digit!")
         .required("Business Phone is required")
   });

   const formik = useFormik({
      initialValues: {
         name: userData?.vendor?.name ? userData?.vendor?.fristname : "",
         email: userData?.vendor?.email ? userData?.vendor?.email : "",
         businessPhone: userData?.vendor?.businessPhone ? userData?.vendor?.businessPhone : "",
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {

         const informationObj = {
            name: values.name,
            email: values.email,
            businessPhone: values.businessPhone,
            image: mainImageName,
         }
         await userUpdate(informationObj);

         setSubmitting(false);
      }
   });

   const { mutateAsync: userUpdate } = useMutation(
      async (data) => {
         return await axiosPrivate.patch(AUTH_API_URL.editProfile + userData?.vendor?._id, data)
      },
      {
         onSuccess: ({ data }) => {
            enqueueSnackbar("Details Update successfully", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
         },
         onError: (error) => {
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "name") {
                  setFieldError("name", errorData[key]);
               } else if (key === "email") {
                  setFieldError("email", errorData[key]);
               } else if (key === "businessPhone") {
                  setFieldError("businessPhone", errorData[key]);
               }
            });
         },
      }
   );

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, setFieldTouched } = formik;

   const handleKycPicOnChange = async (ev) => {
      if (ev.type.includes("image")) {
         let userImgSrc = URL.createObjectURL(ev);
         const formData = new FormData();
         formData.append('image', ev)
         setKycPic(userImgSrc);
         const imageData = await axiosPrivate.post(AUTH_API_URL.uploadImage, formData)
         setKycImageName(imageData?.data?.file_name)
      }
   };

   const handleProfilePicOnChange = async (ev) => {
      if (ev.type.includes("image")) {
         let userImgSrc = URL.createObjectURL(ev);
         const formData = new FormData();
         formData.append('image', ev)
         setProfilePic(userImgSrc);
         const imageData = await axiosPrivate.post(AUTH_API_URL.uploadMainImage, formData)
         setMainImageName(imageData?.data?.file_name)
      }
   };

   const [autoComplete, setAutoComplete] = useState();

   const onAutoCompleteIsLoad = (inputAutoComplete) => {
      setAutoComplete(inputAutoComplete);
   };

   const onAutoCompletePlaceIsChanged = () => {
      // console.log("auto complete is changed: ", autoComplete.getPlace());
      if (autoComplete !== null) {
         var place = autoComplete.getPlace();
         setAddress(place.formatted_address)
         setLocationLat(place.geometry.location.lat());
         setLocationLng(place.geometry.location.lng());
      }
   }

   useEffect(() => {
      let mql = window.matchMedia('(max-width: 768px)');
      window.addEventListener("resize", () => {
         if (mql.matches) {
            setColDir("column")
         } else {
            setColDir("row")
         }
      })
   })


   return (
      <>
         {loding ? <LoadingScreen /> : <>
            <FormikProvider value={formik}>
               <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <div className="container-fluid">
                     <div className="row row-cols-1 g-4">
                        <div className='col'>
                           <div className='user_edit_header'>
                              <h4 className="app_text_14_semibold mb-0">General Information</h4>
                           </div>
                        </div>
                        <div className='col'>
                           <Stack direction={colDir} spacing={2}>
                              <TextField
                                 label="Name"
                                 varient="outlined"
                                 fullWidth
                                 type='text'
                                 autoComplete="off"
                                 {...getFieldProps("name")}
                                 error={Boolean(touched.name && errors.name)}
                                 helperText={touched.name && errors.name}
                              />
                              <TextField
                                 label='Email'
                                 type='email'
                                 autoComplete='off'
                                 fullWidth
                                 variant='outlined'
                                 {...getFieldProps("email")}
                                 error={Boolean(touched.email && errors.email)}
                                 helperText={touched.email && errors.email}
                              />
                           </Stack>
                        </div>
                        <div className='col'>
                           <Stack direction={colDir} spacing={2}>
                              <TextField
                                 label='Business Phone'
                                 type='businessPhone'
                                 autoComplete='off'
                                 fullWidth
                                 variant='outlined'
                                 {...getFieldProps("businessPhone")}
                                 error={Boolean(touched.businessPhone && errors.businessPhone)}
                                 helperText={touched.businessPhone && errors.businessPhone}
                              />
                           </Stack>
                        </div>
                        <div className="col-lg-6">
                           {
                              <div className="img_preview_circle">
                                 <img src={userData?.vendor?.image == null && profilePic == '' ? DefaultImage :
                                    profilePic == '' ? process.env.REACT_APP_PROFILE_URL + 'vendor/' + userData?.vendor?.image : profilePic} alt="profile" />
                              </div>
                           }
                           <Button
                              className="my-4 text-white app_bg_primary app_text_14_500 p-2"
                              variant="contained"
                              component="label"
                           >
                              Change image
                              <input
                                 hidden
                                 accept="image/*"
                                 onChange={(event) => {
                                    const files = event.target.files[0];
                                    handleProfilePicOnChange(files);
                                 }}
                                 type="file"
                              />
                           </Button>
                           <FormHelperText error>
                              {errors.image}
                           </FormHelperText>
                        </div>
                     </div>
                     <div className="col">
                        <div className="col-md-8 m-auto">
                           <Button
                              type="submit"
                              fullWidth
                              variant="contained"
                              className="my-3 text-white app_bg_primary app_text_16_semibold app_btn_lg"
                           >
                              Save Profile
                           </Button>
                        </div>
                     </div>
                  </div>
               </Form>
            </FormikProvider>
         </>
         }
      </>
   )
}

export default SubVendorProfile